import { render } from "./CartButton.vue?vue&type=template&id=baa5fc88"
import script from "./CartButton.vue?vue&type=script&lang=ts"
export * from "./CartButton.vue?vue&type=script&lang=ts"
script.render = render

export default script